import { apiClient } from "./client"

import type { TaskRun } from "@/types"

// PRD-21 §FR-9 — late-join state for the cross-cutting TaskRun
// primitive. Used by ``useTaskProgress`` on mount to seed initial
// state before the next realtime broadcast lands (handles reconnect,
// new-tab, and page-reload cases).
export const taskRunsApi = {
  get: (taskRunId: string) => apiClient.get<TaskRun>(`/task-runs/${taskRunId}`).then((r) => r.data),
}
